// RuleScope[0] = highest priority / scope
// rules processed in scope order, meaning a panel scoped rule would also run PanelItemGroup and PanelItem Rules
export const RuleScope = {
	Blueprint: 0,
	Kitchen: 1,
	Island: 2,
	Panel: 3,
	PanelItemGroup: 4,
	PanelItem: 5,
	Lowest: 6
};
